export const getTimestamp = () => (new Date().toJSON().substring(10, 23).replace('T', ' '));
//# sourceMappingURL=logger.js.map